import { KeyboardBackspace } from '@mui/icons-material'
import { Avatar, Box, Button, IconButton, Skeleton } from '@mui/material'
import { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { rqx } from '../../../../../../core/request/API';
import { env } from '../../../../../../core/Env';
import { ToolContext } from '../../../../../../core/context/ToolContext';

export const ToolAccess = () => {
    const { tool_state } = useContext(ToolContext)
    const { __SESSION, toolOwned } = tool_state

    const [toolAccess, setToolAccess] = useState([])
    const [isLoad, setIsLoad] = useState(false)

    const history = useHistory();

    useEffect(() => {
        const __getTools = async () => {
            setIsLoad(true)
            let all_tools = await rqx.get(`<<global>>/${env()}/tools/read`, {filter: 'category', platform: 'personal', tcid: 'all', ref:'all'})
            if (all_tools.length > 0) {
                const ownedTools = all_tools.filter(at =>
                    toolOwned.data.some(td => td.tid === at.tid)
                );                
                setToolAccess(ownedTools)
                setIsLoad(false)
            }
        }
        __getTools()
        // eslint-disable-next-line
    },[])

    const clickHandler = async(tid) =>{
        let _env = env();
        if (parseInt(process.env.REACT_APP_TID_PSL) !== tid) {
            let res = await rqx.get(`<<global>>/${env() === 'local' ? 'dev' : env()}/tools/toolcb`, {tid: tid, env:_env !== 'prod' ? 'sandbox' : 'production'});
            console.log(res);
            
            if (res.msg === 'success') {
                if (res.tu.length > 0) {
                    window.open(`${res.tu[0].value}?ainfo=${encodeURIComponent(JSON.stringify(__SESSION.data.ainfo))}`, '_blank').focus()
                }
            }
        }
    }

    return (
        <Box width="100%" height="100vh" display="flex" flexDirection="column" gap="16px">
           <Box display="flex" alignItems="center" p="16px">
                <IconButton onClick={() =>  history.goBack(-1)}>
                    <KeyboardBackspace/>
                </IconButton>
                <Box width="80%" textAlign="center" fontSize="14px" fontWeight="600" >Your tool accessed</Box>
           </Box>
           <Box p="24px 16px">
               <Box display="grid" gridTemplateColumns="repeat(2, minmax(100px, 1fr))" gap="24px">
                    {
                        isLoad ?
                            (Array(4).fill(0).map((v, i) => (
                                <Skeleton key={i} variant="rounded" width="100%" height={100} />
                            )))
                        :
                        (toolAccess.map((v, i) => (
                            <Box key={i} component={Button} onClick={() => clickHandler(v.tid)} display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap="12px" py="12px">
                                <Avatar src={JSON.parse(v.logo)} sx={{width: '32px', height: '32px', borderRadius: '4px'}} />
                                <Box display="flex" alignItems="center" justifyContent="center" flexDirection="column" gap="4px">
                                    <Box fontSize="12px" fontWeight="600" color="#292C2F">{v.name}</Box>
                                    <Box fontSize="10px" color="#292C2F">{v.tn_name}</Box>
                                </Box>
                            </Box>
                        )))
                    }
                </Box>
           </Box>
        </Box>
    )
}
